import { render, staticRenderFns } from "./fulfilGiveFullGiveEdit.vue?vue&type=template&id=32446006&"
import script from "./fulfilGiveFullGiveEdit.vue?vue&type=script&lang=js&"
export * from "./fulfilGiveFullGiveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports